module.exports = __webpack_public_path__ + "img/filter.aa57a4e7.svg";